"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../cnpj/dist/index.js
var require_dist = __commonJS({
  "../cnpj/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatCNPJ: () => formatCNPJ2,
      isFormatCNPJ: () => isFormatCNPJ2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatCNPJ2 = (value) => {
      if (value === void 0)
        return void 0;
      return String(value).replace(/\D/g, "").replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d{1,2})/, "$1-$2").replace(/(-\d{2})\d+?$/, "$1");
    };
    var isFormatCNPJ2 = (value) => {
      if (value === void 0)
        return void 0;
      const regex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/;
      return regex.test(value);
    };
  }
});

// ../cpf/dist/index.js
var require_dist2 = __commonJS({
  "../cpf/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatCPF: () => formatCPF2,
      isFormatCPF: () => isFormatCPF2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatCPF2 = (value) => {
      if (value === void 0)
        return void 0;
      if (value === null)
        return void 0;
      const formatToString = String(value);
      const resultReplaces = formatToString.replace(/\D/g, "").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})/, "$1-$2").replace(/(-\d{2})\d+?$/, "$1");
      return resultReplaces;
    };
    var isFormatCPF2 = (value) => {
      if (value === void 0)
        return void 0;
      if (value === null)
        return void 0;
      const regex = /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/;
      const resultRegex = regex.test(value);
      return resultRegex;
    };
  }
});

// ../remove/dist/index.js
var require_dist3 = __commonJS({
  "../remove/dist/index.js"(exports) {
    "use strict";
    exports.__esModule = true;
    exports.formatRemove = void 0;
    var formatRemove2 = function(value) {
      return value.replace(/[^a-z0-9]/gi, "");
    };
    exports.formatRemove = formatRemove2;
  }
});

// ../credCard/dist/index.js
var require_dist4 = __commonJS({
  "../credCard/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatStringCredCard: () => formatStringCredCard2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatStringCredCard2 = (value) => {
      if (value === void 0)
        return void 0;
      return String(value).replace(/\D/g, "").replace(/(\d{4})(\d)/, "$1-$2").replace(/(\d{4})(\d)/, "$1-$2").replace(/(\d{4})(\d)/, "$1-$2").replace(/(-\d{4})\d+?$/, "$1");
    };
  }
});

// ../currency/dist/index.js
var require_dist5 = __commonJS({
  "../currency/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatStringCurrency: () => formatStringCurrency2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatStringCurrency2 = (value) => {
      if (value === void 0)
        return void 0;
      const initialValue = +String(value).replace(/\D/g, "") / 100;
      return initialValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };
  }
});

// ../number/dist/index.js
var require_dist6 = __commonJS({
  "../number/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatStringNumber: () => formatStringNumber2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatStringNumber2 = (value) => {
      if (value === void 0)
        return void 0;
      return String(value).replace(/\D/g, "");
    };
  }
});

// ../phone/dist/index.js
var require_dist7 = __commonJS({
  "../phone/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatStringPhone: () => formatStringPhone2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatStringPhone2 = (value) => {
      if (value === void 0)
        return void 0;
      return String(value).replace(/\D/g, "").replace(/(\d{0})(\d)/, "$1($2").replace(/(\d{2})(\d)/, "$1) $2").replace(/(\d{1})(\d+?$)/, "$1 $2").replace(/(\d{4})(\d{1,2})/, "$1-$2").replace(/(-\d{4})\d+?$/, "$1");
    };
  }
});

// ../postalCode/dist/index.js
var require_dist8 = __commonJS({
  "../postalCode/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatStringPostalCode: () => formatStringPostalCode2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatStringPostalCode2 = (value) => {
      if (value === void 0)
        return void 0;
      return String(value).replace(/\D/g, "").replace(/(\d{5})(\d)/, "$1-$2").replace(/(-\d{3})\d+?$/, "$1");
    };
  }
});

// ../rg/dist/index.js
var require_dist9 = __commonJS({
  "../rg/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatStringRG: () => formatStringRG2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatStringRG2 = (value) => {
      if (value === void 0)
        return void 0;
      return String(value).replace(/\D/g, "").replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})/, "$1-$2").replace(/(-\d{1})\d+?$/, "$1");
    };
  }
});

// ../credCardExpirationDate.ts/dist/index.js
var require_dist10 = __commonJS({
  "../credCardExpirationDate.ts/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatStringCredCardExpirationDate: () => formatStringCredCardExpirationDate2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatStringCredCardExpirationDate2 = (value) => {
      if (value === void 0)
        return void 0;
      return String(value).replace(/\D/g, "").replace(/(\d{2})(\d)/, "$1/$2").replace(/(\/\d{4})\d+?$/, "$1");
    };
  }
});

// ../telephone/dist/index.js
var require_dist11 = __commonJS({
  "../telephone/dist/index.js"(exports, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      formatStringTelephone: () => formatStringTelephone2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var formatStringTelephone2 = (value) => {
      if (!value)
        return void 0;
      return String(value).replace(/\D/g, "").replace(/(\d{0})(\d)/, "$1($2").replace(/(\d{2})(\d)/, "$1) $2").replace(/(\d{4})(\d{1,2})/, "$1-$2").replace(/(-\d{4})\d+?$/, "$1");
    };
  }
});

// ../SinglePhone/dist/index.js
var require_dist12 = __commonJS({
  "../SinglePhone/dist/index.js"(exports, module2) {
    "use strict";
    var __create2 = Object.create;
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __getProtoOf2 = Object.getPrototypeOf;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __commonJS2 = (cb, mod) => function __require() {
      return mod || (0, cb[__getOwnPropNames2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toESM2 = (mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(
      // If the importer is in node compatibility mode or this is not an ESM
      // file that has been converted to a CommonJS file using a Babel-
      // compatible transform (i.e. "__esModule" has not been set), then set
      // "default" to the CommonJS "module.exports" for node compatibility.
      isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
      mod
    ));
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var require_dist14 = __commonJS2({
      "../phone/dist/index.js"(exports2, module22) {
        "use strict";
        var __defProp22 = Object.defineProperty;
        var __getOwnPropDesc22 = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames22 = Object.getOwnPropertyNames;
        var __hasOwnProp22 = Object.prototype.hasOwnProperty;
        var __export22 = (target, all) => {
          for (var name in all)
            __defProp22(target, name, { get: all[name], enumerable: true });
        };
        var __copyProps22 = (to, from, except, desc) => {
          if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames22(from))
              if (!__hasOwnProp22.call(to, key) && key !== except)
                __defProp22(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc22(from, key)) || desc.enumerable });
          }
          return to;
        };
        var __toCommonJS22 = (mod) => __copyProps22(__defProp22({}, "__esModule", { value: true }), mod);
        var src_exports22 = {};
        __export22(src_exports22, {
          formatStringPhone: () => formatStringPhone2
        });
        module22.exports = __toCommonJS22(src_exports22);
        var formatStringPhone2 = (value) => {
          if (value === void 0)
            return void 0;
          return String(value).replace(/\D/g, "").replace(/(\d{0})(\d)/, "$1($2").replace(/(\d{2})(\d)/, "$1) $2").replace(/(\d{1})(\d+?$)/, "$1 $2").replace(/(\d{4})(\d{1,2})/, "$1-$2").replace(/(-\d{4})\d+?$/, "$1");
        };
      }
    });
    var require_dist22 = __commonJS2({
      "../telephone/dist/index.js"(exports2, module22) {
        "use strict";
        var __defProp22 = Object.defineProperty;
        var __getOwnPropDesc22 = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames22 = Object.getOwnPropertyNames;
        var __hasOwnProp22 = Object.prototype.hasOwnProperty;
        var __export22 = (target, all) => {
          for (var name in all)
            __defProp22(target, name, { get: all[name], enumerable: true });
        };
        var __copyProps22 = (to, from, except, desc) => {
          if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames22(from))
              if (!__hasOwnProp22.call(to, key) && key !== except)
                __defProp22(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc22(from, key)) || desc.enumerable });
          }
          return to;
        };
        var __toCommonJS22 = (mod) => __copyProps22(__defProp22({}, "__esModule", { value: true }), mod);
        var src_exports22 = {};
        __export22(src_exports22, {
          formatStringTelephone: () => formatStringTelephone2
        });
        module22.exports = __toCommonJS22(src_exports22);
        var formatStringTelephone2 = (value) => {
          if (!value)
            return void 0;
          return String(value).replace(/\D/g, "").replace(/(\d{0})(\d)/, "$1($2").replace(/(\d{2})(\d)/, "$1) $2").replace(/(\d{4})(\d{1,2})/, "$1-$2").replace(/(-\d{4})\d+?$/, "$1");
        };
      }
    });
    var src_exports2 = {};
    __export2(src_exports2, {
      formatSinglePhone: () => formatSinglePhone2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var import_phone2 = __toESM2(require_dist14());
    var import_telephone2 = __toESM2(require_dist22());
    var formatSinglePhone2 = (value) => {
      if (value === void 0)
        return void 0;
      if (String(value).length <= 14) {
        return (0, import_telephone2.formatStringTelephone)(value);
      } else {
        return (0, import_phone2.formatStringPhone)(value);
      }
    };
  }
});

// ../singleDocument/dist/index.js
var require_dist13 = __commonJS({
  "../singleDocument/dist/index.js"(exports, module2) {
    "use strict";
    var __create2 = Object.create;
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __getProtoOf2 = Object.getPrototypeOf;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __commonJS2 = (cb, mod) => function __require() {
      return mod || (0, cb[__getOwnPropNames2(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toESM2 = (mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(
      // If the importer is in node compatibility mode or this is not an ESM
      // file that has been converted to a CommonJS file using a Babel-
      // compatible transform (i.e. "__esModule" has not been set), then set
      // "default" to the CommonJS "module.exports" for node compatibility.
      isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
      mod
    ));
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var require_dist14 = __commonJS2({
      "../cpf/dist/index.js"(exports2, module22) {
        "use strict";
        var __defProp22 = Object.defineProperty;
        var __getOwnPropDesc22 = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames22 = Object.getOwnPropertyNames;
        var __hasOwnProp22 = Object.prototype.hasOwnProperty;
        var __export22 = (target, all) => {
          for (var name in all)
            __defProp22(target, name, { get: all[name], enumerable: true });
        };
        var __copyProps22 = (to, from, except, desc) => {
          if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames22(from))
              if (!__hasOwnProp22.call(to, key) && key !== except)
                __defProp22(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc22(from, key)) || desc.enumerable });
          }
          return to;
        };
        var __toCommonJS22 = (mod) => __copyProps22(__defProp22({}, "__esModule", { value: true }), mod);
        var src_exports22 = {};
        __export22(src_exports22, {
          formatCPF: () => formatCPF2,
          isFormatCPF: () => isFormatCPF2
        });
        module22.exports = __toCommonJS22(src_exports22);
        var formatCPF2 = (value) => {
          if (value === void 0)
            return void 0;
          if (value === null)
            return void 0;
          const formatToString = String(value);
          const resultReplaces = formatToString.replace(/\D/g, "").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})/, "$1-$2").replace(/(-\d{2})\d+?$/, "$1");
          return resultReplaces;
        };
        var isFormatCPF2 = (value) => {
          if (value === void 0)
            return void 0;
          if (value === null)
            return void 0;
          const regex = /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/;
          const resultRegex = regex.test(value);
          return resultRegex;
        };
      }
    });
    var require_dist22 = __commonJS2({
      "../cnpj/dist/index.js"(exports2, module22) {
        "use strict";
        var __defProp22 = Object.defineProperty;
        var __getOwnPropDesc22 = Object.getOwnPropertyDescriptor;
        var __getOwnPropNames22 = Object.getOwnPropertyNames;
        var __hasOwnProp22 = Object.prototype.hasOwnProperty;
        var __export22 = (target, all) => {
          for (var name in all)
            __defProp22(target, name, { get: all[name], enumerable: true });
        };
        var __copyProps22 = (to, from, except, desc) => {
          if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames22(from))
              if (!__hasOwnProp22.call(to, key) && key !== except)
                __defProp22(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc22(from, key)) || desc.enumerable });
          }
          return to;
        };
        var __toCommonJS22 = (mod) => __copyProps22(__defProp22({}, "__esModule", { value: true }), mod);
        var src_exports22 = {};
        __export22(src_exports22, {
          formatCNPJ: () => formatCNPJ2,
          isFormatCNPJ: () => isFormatCNPJ2
        });
        module22.exports = __toCommonJS22(src_exports22);
        var formatCNPJ2 = (value) => {
          if (value === void 0)
            return void 0;
          return String(value).replace(/\D/g, "").replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d{1,2})/, "$1-$2").replace(/(-\d{2})\d+?$/, "$1");
        };
        var isFormatCNPJ2 = (value) => {
          if (value === void 0)
            return void 0;
          const regex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/;
          return regex.test(value);
        };
      }
    });
    var src_exports2 = {};
    __export2(src_exports2, {
      formatSingleDocument: () => formatSingleDocument2,
      isFormatSingleDocument: () => isFormatSingleDocument2
    });
    module2.exports = __toCommonJS2(src_exports2);
    var import_cpf2 = __toESM2(require_dist14());
    var import_cnpj2 = __toESM2(require_dist22());
    var formatSingleDocument2 = (value) => {
      if (value === void 0)
        return void 0;
      if (String(value).length <= 14) {
        return (0, import_cpf2.formatCPF)(value);
      } else {
        return (0, import_cnpj2.formatCNPJ)(value);
      }
    };
    var isFormatSingleDocument2 = (value) => {
      if (value === void 0)
        return void 0;
      if (value.length <= 14 && (0, import_cpf2.isFormatCPF)(value)) {
        return "cpf";
      } else if ((0, import_cnpj2.isFormatCNPJ)(value)) {
        return "cnpj";
      } else {
        return void 0;
      }
    };
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  formatRemove: () => import_remove.formatRemove,
  formatString: () => formatString,
  isFormatCNPJ: () => import_cnpj.isFormatCNPJ,
  isFormatCPF: () => import_cpf.isFormatCPF,
  isFormatSingleDocument: () => import_single_document.isFormatSingleDocument
});
module.exports = __toCommonJS(src_exports);
var import_cnpj = __toESM(require_dist());
var import_cpf = __toESM(require_dist2());
var import_remove = __toESM(require_dist3());
var import_cred_card = __toESM(require_dist4());
var import_currency = __toESM(require_dist5());
var import_number = __toESM(require_dist6());
var import_phone = __toESM(require_dist7());
var import_postal_code = __toESM(require_dist8());
var import_rg = __toESM(require_dist9());
var import_cred_card_expiration_date = __toESM(require_dist10());
var import_telephone = __toESM(require_dist11());
var import_single_phone = __toESM(require_dist12());
var import_single_document = __toESM(require_dist13());
var formatString = ({ value, type }) => {
  const asMaskSelect = {
    cnpj: (0, import_cnpj.formatCNPJ)(value),
    cpf: (0, import_cpf.formatCPF)(value),
    credCard: (0, import_cred_card.formatStringCredCard)(value),
    cardExpirationDate: (0, import_cred_card_expiration_date.formatStringCredCardExpirationDate)(value),
    cpfOurCnpj: (0, import_single_document.formatSingleDocument)(value),
    currency: (0, import_currency.formatStringCurrency)(value),
    number: (0, import_number.formatStringNumber)(value),
    obscureEmail: (0, import_single_document.formatSingleDocument)(value),
    phone: (0, import_phone.formatStringPhone)(value),
    postalCode: (0, import_postal_code.formatStringPostalCode)(value),
    rg: (0, import_rg.formatStringRG)(value),
    telephone: (0, import_telephone.formatStringTelephone)(value),
    phoneOrTelephone: (0, import_single_phone.formatSinglePhone)(value)
  };
  return asMaskSelect[type];
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  formatRemove,
  formatString,
  isFormatCNPJ,
  isFormatCPF,
  isFormatSingleDocument
});
